const EXTERNAL_ID_KEY = 'external_id';
const TTL_MS = 30 * 60 * 1000;

interface ExternalId {
	id: string;
	currentDate: number;
}

export const generateExternalId = (): string => {
	const randNum = Math.floor(Math.random() * 50000) + 1;
	const unixTime = Math.floor(Date.now() / 1000);
	const external_id = randNum.toString() + unixTime.toString();
	return external_id;
};

const setExternalId = (id: string): void => {
	try {
		localStorage.setItem(
			EXTERNAL_ID_KEY,
			JSON.stringify({ id, currentDate: Date.now() } satisfies ExternalId)
		);
	} catch {}
};

export const getExternalIdRecord = (): ExternalId | null => {
	try {
		const raw = localStorage.getItem(EXTERNAL_ID_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw) as Partial<ExternalId>;
		if (typeof parsed?.id !== 'string' || typeof parsed?.currentDate !== 'number') return null;
		return parsed as ExternalId;
	} catch {
		return null;
	}
};

export const getExternalId = (): string => {
	if (typeof window === 'undefined') return '';
	return getExternalIdRecord()?.id ?? '';
};

export const getOrCreateExternalId = (): string => {
	if (typeof window === 'undefined') return '';

	const externalId = getExternalIdRecord();
	if (externalId && Date.now() - externalId.currentDate < TTL_MS) {
		setExternalId(externalId.id);
		return externalId.id;
	}

	const newExternalId = generateExternalId();
	setExternalId(newExternalId);
	return newExternalId;
};
